import type { Channel } from './types'

const DEFAULT_DELAYS = [0, 300, 700, 1400, 2600]

const wait = (delay: number) => new Promise<void>((resolve) => window.setTimeout(resolve, delay))

export async function reconcileConnectedChannel({
  platform,
  reload,
  readChannels,
  delays = DEFAULT_DELAYS,
  sleep = wait,
}: {
  platform: string
  reload: () => Promise<void>
  readChannels: () => Channel[]
  delays?: number[]
  sleep?: (delay: number) => Promise<void>
}) {
  for (const delay of delays) {
    if (delay > 0) await sleep(delay)
    await reload()
    if (readChannels().some((channel) => channel.platform === platform)) {
      return true
    }
  }
  return false
}
